// extracted by mini-css-extract-plugin
export default {"cssfortimediv":"Updaterecentjobs_cssfortimediv__xxBkB","inputtime":"Updaterecentjobs_inputtime__2dKbW"};